import client from './client';
import Versions from './Version';
import Controllers from './Controller';
import Warnings from './Warning';
import Rooms from './Rooms';
import Sensor from './Sensor';
import Profile from './Profile';
export class Api {
}
Api.Profile = new Profile(client);
Api.Controllers = new Controllers(client);
Api.Version = new Versions(client);
Api.Rooms = new Rooms(client);
Api.Warnings = new Warnings(client);
Api.Sensor = new Sensor(client);
